import { CheckboxesValue } from '@shared/FormV2/fields';

export const prepareValueOfComplaintCategory = (
  value: CheckboxesValue,
): number[] =>
  Object.entries(value)
    .filter(([, value]) => value)
    .map(([key]) => +key);
